const customCollapsibleContent = document.querySelectorAll(
  ".custom-collapsible-content"
);

let currentClickedAccordion;

function closeAllCollapsibleRows(e) {
  if (currentClickedAccordion.getAttribute("aria-expanded") === "false") {
    document
      .querySelectorAll(".custom-accordion")
      .forEach((customAccordion) => {
        customAccordion.setAttribute("aria-expanded", "false");
      });
    document
      .querySelectorAll(".custom-accordion__content")
      .forEach((customAccordion) => {
        customAccordion.setAttribute("aria-hidden", "false");
      });
  }
}

const hideAndShowRows = (element) => {
  function toggleHeightControl(clickedAccordion) {
    const clickedAccordionContent = clickedAccordion.querySelector(
      ".custom-accordion__content"
    );
    const isExpanded =
      clickedAccordionContent.getAttribute("aria-hidden") === "true";
    if (isExpanded) {
      clickedAccordionContent.setAttribute("aria-hidden", "false");
      clickedAccordion.setAttribute("aria-expanded", "false");
    } else {
      clickedAccordion.setAttribute("aria-expanded", "true");
      clickedAccordionContent.setAttribute("aria-hidden", "true");
    }
  }
  element.forEach((customCollapsibleContent) => {
    customCollapsibleContent.addEventListener("click", (e) => {
      currentClickedAccordion = e.target.closest(".custom-accordion");
      if (
        e.target.closest(".custom-accordion") &&
        !e.target.closest(".custom-accordion__content")
      ) {
        closeAllCollapsibleRows();
        toggleHeightControl(e.target.closest(".custom-accordion"));
      } else {
        return;
      }
    });
  });
};

hideAndShowRows(customCollapsibleContent);
